import { Typography } from '@mui/material';

import {
  IconAttachFileMS,
  IconCloseMS,
} from '../../../../../../constants/icons';
import { RichTextViewer } from '../../../../../Announcements/components/RichTextViewer';
import {
  CloseButtonBox,
  CloseIcon,
  DialogContainer,
  StyledDialog,
  TextTypography,
} from '../styles';

interface RejectionReasonDialogProps {
  open: boolean;
  closeDialog: () => void;
  rejectionReason: string;
  document: string;
}

export function RejectReasonDialog({
  open,
  closeDialog,
  rejectionReason,
  document,
}: RejectionReasonDialogProps): JSX.Element {
  return (
    <StyledDialog open={open} onClose={closeDialog}>
      <CloseButtonBox>
        <CloseIcon onClick={closeDialog}>{IconCloseMS}</CloseIcon>
      </CloseButtonBox>
      <DialogContainer>
        <Typography>Motivo</Typography>
        <TextTypography>
          {IconAttachFileMS}
          {document}
        </TextTypography>
        <RichTextViewer content={rejectionReason} />
      </DialogContainer>
    </StyledDialog>
  );
}
